import request from '@/utils/request'

export function getArticleById(id) {
    return request({
        url: '/profile/article/'+id,
        method: 'get',
    })
}

// 参数样例
// const params = {
//   pageNum: 1,
//   pageSize: 10,
//   bindId: undefined,
//   isAsc: "desc",
//   orderByColumn: "createdTime"
//   articleTypeCode: 位置
// };

export function getArticlePage(params) {
    return request({
        url: '/profile/article/page',
        method: 'get',
        params: params
    })
}

